import { FileService, CommonService } from '@common/lib/api';
import * as common from './types';

const actions = {
  [common.SHOW_LOADING]({ commit }) {
    commit(common.SET_LOADING, true);
  },
  [common.HIDE_LOADING]({ commit }) {
    commit(common.SET_LOADING, false);
  },
  [common.SET_LOADING]({ commit }, value) {
    commit(common.SET_LOADING, value);
  },
  [common.GLOBAL_MESSAGE]({ commit }, message) {
    if (typeof message === 'string') {
      message = {
        message: message,
      };
    }

    if (!message.level) {
      message.level = 'info';
    }

    if (!parseInt(message.duration)) {
      message.duration = 3000;
    }

    commit(common.PUT_GLOBAL_MESSAGE, message);

    setTimeout(() => {
      commit(common.DELETE_GLOBAL_MESSAGE, message);
    }, message.duration);
  },
  [common.SET_LOAD]({ commit }) {
    //commit(common.SET_LOAD, true);
  },
  [common.SET_SNACKBAR]({ commit }, data) {
    commit(common.SET_SNACKBAR, data);
  },
  [common.SHOW_SNACKBAR]({ commit }) {
    commit(common.SET_SHOW_SNACKBAR, true);
  },
  [common.HIDE_SNACKBAR]({ commit }) {
    commit(common.SET_SHOW_SNACKBAR, false);
  },
  [common.SET_DIALOG]({ commit }, data) {
    commit(common.SET_DIALOG, data);
  },
  [common.SHOW_DIALOG]({ commit }) {
    commit(common.SET_SHOW_DIALOG, true);
  },
  [common.HIDE_DIALOG]({ commit }) {
    commit(common.SET_SHOW_DIALOG, false);
  },
  [common.DIALOG_OK]({ commit }) {
    commit(common.DIALOG_OK);
  },
  [common.DIALOG_CANCEL]({ commit }) {
    commit(common.DIALOG_CANCEL);
  },
  [common.TOGGLE_NAV_DRAWER]({ commit }) {
    commit(common.TOGGLE_NAV_DRAWER);
  },
  [common.TOGGLE_NAV_MINI]({ commit }) {
    commit(common.TOGGLE_NAV_MINI);
  },
  [common.SHOW_REQUIRED_UPDATE_PASSWORD_DIALOG]({ commit }) {
    commit(common.SET_REQUIRED_UPDATE_PASSWORD_DIALOG, true);
  },
  [common.HIDE_REQUIRED_UPDATE_PASSWORD_DIALOG]({ commit }) {
    commit(common.SET_REQUIRED_UPDATE_PASSWORD_DIALOG, false);
  },
  [common.SET_APPINFO]({ commit }, value) {
    commit(common.SET_APPINFO, value);
  },
  async [common.FILE_UPLOAD](context, payload) {
    const { data } = await FileService.upload(payload);

    return data;
  },
  async [common.FETCH_APPINFO]({ commit }) {
    const { data } = await CommonService.getAppInfo();
    commit(common.SET_APPINFO, data);

    return data;
  },
  [common.SET_CUSTOM_HEADER_TEXT]({ commit }, text) {
    commit(common.SET_CUSTOM_HEADER_TEXT, text);
  },
  async [common.FETCH_SEARCH](commit, payload) {
    const { data } = await CommonService.getSearch(payload);
    return data;
  },
};

export default actions;
